import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationEventService } from '../../services/event/notification-event.service';
import { NotificationEvent } from '../../models/events/notification-event.model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-edit-notification-event',
    templateUrl: './edit-notification-event.component.html',
    styleUrls: ['./edit-notification-event.component.css']
})
/** edit-notification-event component*/
export class EditNotificationEventComponent {
  notificationEvent = new NotificationEvent();
    /** edit-notification-event ctor */
  constructor(private _avRoute: ActivatedRoute,
    private notificationEventService: NotificationEventService, private _router: Router,
    private readonly toastr: ToastsManager, vcr: ViewContainerRef, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("notificationevent").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            if (this._avRoute.snapshot.params["id"]) {
              this.getNotificationEventById(this._avRoute.snapshot.params["id"]);
            }
          }
          else {
            this._router.navigate(["/notification-event-list"]);
          }
        }
        else {
          this._router.navigate(["/notification-event-list"]);
        }
      }
    )
  }

  getNotificationEventById(id: string) {
    this.notificationEventService.GetNotificationEventById(id).subscribe(
      data => {
        this.notificationEvent = data;
      }
    )
  }

  onSubmit() {
    this.toastr.success('Event Notification updated successfully.', 'Success');
    this.notificationEventService.UpdateNotificationEvent(this.notificationEvent);
  }
}



// WEBPACK FOOTER //
// ./src/app/event-components/edit-notification-event/edit-notification-event.component.ts